import React from 'react';
import { businessInfo } from '../data/mock';

const LINKS = [
  { id: 'services', label: 'Services' },
  { id: 'reviews', label: 'Reviews' },
  { id: 'quote', label: 'Get Quote' },
];

export const Footer = () => {
  return (
    <footer className="bg-neutral-950 border-t-4 border-red-600" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <img src="/images/logo.png" alt="Stefen's Detailing" className="h-20 w-auto mb-4" />
            <p className="text-white/60 max-w-xs">
              Premium mobile detailing services bringing professional results to your location.
            </p>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-wider text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => document.getElementById(link.id).scrollIntoView({ behavior: 'smooth' })}
                    className="text-white/60 hover:text-red-500"
                    data-testid={`footer-link-${link.id}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-wider text-white font-bold mb-4">Contact</h4>
            <ul className="space-y-2 text-white/60">
              <li>
                <a href={`tel:${businessInfo.phone}`} className="hover:text-red-500" data-testid="footer-phone-link">
                  {businessInfo.phone}
                </a>
              </li>
              <li>{businessInfo.serviceArea}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-white/40 text-sm">
          <p>© {new Date().getFullYear()} {businessInfo.name}. All rights reserved.</p>
          <a href="/admin" className="inline-block mt-2 text-white/30 hover:text-white/70 text-xs" data-testid="footer-owner-login">Owner login</a>
        </div>
      </div>
    </footer>
  );
};
